import keysOf from 'utils/keysOf';

const mapValues = <O extends object, R>(
  object: O,
  callback: (value: O[keyof O], key: keyof O) => R
): Record<keyof O, R> =>
  keysOf(object).reduce((acc, curr) => ({ ...acc, [curr]: callback(object[curr], curr) }), {} as Record<keyof O, R>);

export default mapValues;
